import React from 'react';
import { Grid } from '@mui/material';
import { Create, SimpleForm, required, TextInput } from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { CNPJInput } from '../../components/Inputs';

const CompanyWithoutPointCreate = (props) => {
    return (
        <Permission permission={PERMISSIONS.MANAGE_COMPANY_WITHOUT_POINT}>
            <Create title='Adicionar CNPJ na exclusão' {...props}>
                <SimpleForm>
                    <Grid container spacing={2} alignItems="flex-start" sx={{ width: '100%' }}>
                        <Grid size={{ xs: 12, sm: 'auto' }}>
                            <TextInput
                                source="name"
                                label="Nome"
                                fullWidth={false}
                                sx={{ width: { xs: '100%', sm: 280 } }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 'auto' }}>
                            <CNPJInput
                                source="cnpj"
                                label="CNPJ"
                                validate={required()}
                                fullWidth={false}
                                sx={{ width: { xs: '100%', sm: 280 } }}
                            />
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
        </Permission>
    );
};

export default CompanyWithoutPointCreate;
